import { createHashHistory, createBrowserHistory } from 'history';

export const history = createBrowserHistory();


// export const history = createHashHistory({
//     basename: '/',
//     hashType: 'slash'
// });

export const link = 'https://api.opptimise.in'



// WEBPACK FOOTER //
// ./src/_helpers/history.js